import {GenogramSexualCommunicationEnum} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/GenogramSexualCommunicationEnum";

export const SEXUAL_COMMUNICATION_FIELD = "sexualCommunication"
export const SEXUAL_COMMUNICATION_LABEL = "Sexual Communication"
export const SEXUAL_COMMUNICATION_TOOLTIP = "From the sexual genogram: Sex+ means positive/open sexual communication, Sex- means negative/closed sexual communication, and SexØ means sex neutral."

const SEXUAL_COMMUNICATION_OPTIONS = [
	{value: "", label: "Not selected"},
	{value: GenogramSexualCommunicationEnum.SEX_POSITIVE, label: "Sex+"},
	{value: GenogramSexualCommunicationEnum.SEX_NEGATIVE, label: "Sex-"},
	{value: GenogramSexualCommunicationEnum.SEX_NEUTRAL, label: "SexØ"},
]

const SEXUAL_COMMUNICATION_LABEL_MAP = SEXUAL_COMMUNICATION_OPTIONS.reduce((acc, option) => {
	if(option.value){
		acc[option.value] = option.label
	}
	return acc
}, {})

const SEXUAL_COMMUNICATION_LEGEND_LABEL_MAP = {
	[GenogramSexualCommunicationEnum.SEX_POSITIVE]: "Positive Sexual Communication",
	[GenogramSexualCommunicationEnum.SEX_NEGATIVE]: "Negative Sexual Communication",
	[GenogramSexualCommunicationEnum.SEX_NEUTRAL]: "Neutral Sexual Communication",
}

export function getSexualCommunicationOptions() {
	return SEXUAL_COMMUNICATION_OPTIONS
}

export function getSexualCommunicationLabel(value) {
	return SEXUAL_COMMUNICATION_LABEL_MAP[value] || ""
}

export function getSexualCommunicationLegendLabel(value) {
	return SEXUAL_COMMUNICATION_LEGEND_LABEL_MAP[value] || getSexualCommunicationLabel(value)
}

export function hasSexualCommunicationValue(value) {
	return !!getSexualCommunicationLabel(value)
}
